module.exports = __webpack_public_path__ + "static/media/ic-choose-design.1377499d.svg";